// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__29p0s","content":"styles_content__3iYRl","checkbox":"styles_checkbox__1pvQ_","checkboxLabel":"styles_checkboxLabel__1QgI0"};